var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRoundPlus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "round_plus",
    transform: "translate(-1283 -609)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "add_circle_FILL0_wght400_GRAD0_opsz48",
    d: "M89.325,191h1.5v-4.15H95v-1.5H90.825V181h-1.5v4.35H85v1.5h4.325Zm.682,5a9.679,9.679,0,0,1-3.888-.788,10.1,10.1,0,0,1-5.332-5.334,10.009,10.009,0,0,1,0-7.783,10.006,10.006,0,0,1,2.15-3.171,10.264,10.264,0,0,1,3.184-2.137,10.009,10.009,0,0,1,7.783,0,9.995,9.995,0,0,1,5.309,5.313,10,10,0,0,1,0,7.781,10.213,10.213,0,0,1-2.138,3.177,10.1,10.1,0,0,1-3.175,2.15A9.673,9.673,0,0,1,90.007,196Zm.006-1.5a8.493,8.493,0,1,0-6.025-2.488A8.165,8.165,0,0,0,90.012,194.5ZM90,186Z",
    transform: "translate(1205 435)",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_5153",
    "data-name": "\\u9577\\u65B9\\u5F62 5153",
    width: 24,
    height: 24,
    transform: "translate(1283 609)",
    fill: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundPlus);
export default __webpack_public_path__ + "static/media/round_plus.97682c1688c101750c87b13883f7bf88.svg";
export { ForwardRef as ReactComponent };